import { createAsyncAction } from 'typesafe-actions'
import {
  ReadUserBankAccountsRequestDto,
  ReadUserBankAccountsResponseDto,
  UpdateUserBankAccountStatusRequestDto,
  UpdateUserBankAccountResponseDto,
} from '@sparling/financial-common'

export const {
  request: getUserBankAccountsRequest,
  success: getUserBankAccountsSuccess,
  failure: getUserBankAccountsFailure,
} = createAsyncAction(
  'GET_USER_BANK_ACCOUNTS_REQUEST',
  'GET_USER_BANK_ACCOUNTS_SUCCESS',
  'GET_USER_BANK_ACCOUNTS_FAILURE',
)<ReadUserBankAccountsRequestDto & { idSf: string }, ReadUserBankAccountsResponseDto, Error>()

export const {
  request: updateUserBankAccountStatusRequest,
  success: updateUserBankAccountStatusSuccess,
  failure: updateUserBankAccountStatusFailure,
} = createAsyncAction(
  'UPDATE_USER_BANK_ACCOUNTS_REQUEST',
  'UPDATE_USER_BANK_ACCOUNTS_SUCCESS',
  'UPDATE_USER_BANK_ACCOUNTS_FAILURE',
)<UpdateUserBankAccountStatusRequestDto, UpdateUserBankAccountResponseDto, Error>()
